import { useCallback } from 'react';
import { IdentificationFormStepNames } from '../types';
import store from '~/store/store';
import { TOwnershipStructure } from '../forms/OwnershipStructure/types';
import { TGeneralInfoLegalResident } from '../forms/GeneralInfo/types';

export const useGetIsStepDisabled = () => {
  return useCallback((name?: string) => {
    const isBeneficiariesAbsent = (
      store.getState().identification.formData.ownershipStructure as TOwnershipStructure
    )?.isBeneficiariesAbsent;

    const {
      isOtherTaxResident,
      isControllingPersonTaxResidentOtherJurisdiction,
      isUSTaxResident,
      isForeignFinancialUnderFATCA,
      isControllingPersonUSTaxResident,
    } = (store.getState().identification.formData.generalInfo as TGeneralInfoLegalResident) || {};

    const needsTaxResidencyStep =
      isOtherTaxResident || isControllingPersonTaxResidentOtherJurisdiction;

    const needsFatcaAdditionalInformation =
      isUSTaxResident || isForeignFinancialUnderFATCA || isControllingPersonUSTaxResident;

    return (
      (name === IdentificationFormStepNames.additionalInformation && isBeneficiariesAbsent) ||
      (name === IdentificationFormStepNames.taxResidencyAdditionalInformation &&
        !needsTaxResidencyStep) ||
      (name === IdentificationFormStepNames.fatcaAdditionalInformation &&
        !needsFatcaAdditionalInformation)
    );
  }, []);
};
